import { LitElement, css, html } from 'lit';

import { StateController } from '../helpers/state/state-management/state-controller';
import { customElement } from 'lit/decorators';
import topicData from '../helpers/state/topic-data';

@customElement('bookmark-map-modal')
export class BookmarkMapModal extends LitElement {
    static amplitude_callsite: string = 'Bookmark Map';

    private readonly bindTopicState = new StateController(this, topicData);

    protected render() {
        return html`
            <div class="image"><img src="/images/backpack.png" /></div>
            <div class="text">
                <p><b>${topicData.name}</b> <translated-span>has been bookmarked to your Proxi backpack!</translated-span> </p>
            </div>
            <br />
            <mwc-button raised class="backpack" @click="${() => window.open(`/#home`)}">
                <translated-span>Visit Your Proxi Backpack</translated-span>
            </mwc-button>
        `;
    }

    static get styles() {
        return css`
            .image {
                float: left;
                padding-top: 25px;
            }

            .image img {
                width: 100px;
                max-width: 15vw;
            }

            .text {
                float: right;
                padding: 25px;
                max-width: 200px;
            }

            .backpack {
                --mdc-theme-primary: var(--main-primary-color);
                --mdc-typography-button-font-size: 0.75rem;
                border-radius: 5px;
                margin-left: 5px;
                margin-right: 5px;
                width: 100%;
            }
        `;
    }
}
